import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  iconfont:
    "mdiSvg" || "mdi" || "fa" || "fa4" || "faSvg" || "fa4Svg" || "faSvg4",
});
